'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _functionTree = require('function-tree');

var _functionTree2 = _interopRequireDefault(_functionTree);

var _Module = require('./Module');

var _Module2 = _interopRequireDefault(_Module);

var _utils = require('./utils');

var _VerifyProps = require('./providers/VerifyProps');

var _VerifyProps2 = _interopRequireDefault(_VerifyProps);

var _Debugger = require('./providers/Debugger');

var _Debugger2 = _interopRequireDefault(_Debugger);

var _Controller = require('./providers/Controller');

var _Controller2 = _interopRequireDefault(_Controller);

var _Resolve = require('./providers/Resolve');

var _Resolve2 = _interopRequireDefault(_Resolve);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
  The controller is where everything is attached. The devtools
  and router is attached directly. Also a top level module is created.
  The controller creates the function tree that will run all signals,
  based on top level providers and providers defined in modules
*/
var BaseController = function (_FunctionTree) {
  _inherits(BaseController, _FunctionTree);

  function BaseController(config) {
    _classCallCheck(this, BaseController);

    var _this = _possibleConstructorReturn(this, (BaseController.__proto__ || Object.getPrototypeOf(BaseController)).call(this));

    var _config$state = config.state,
        state = _config$state === undefined ? {} : _config$state,
        _config$signals = config.signals,
        signals = _config$signals === undefined ? {} : _config$signals,
        _config$providers = config.providers,
        providers = _config$providers === undefined ? [] : _config$providers,
        _config$modules = config.modules,
        modules = _config$modules === undefined ? {} : _config$modules,
        _config$devtools = config.devtools,
        devtools = _config$devtools === undefined ? null : _config$devtools,
        _config$options = config.options,
        options = _config$options === undefined ? {} : _config$options;

    var getSignal = _this.getSignal;

    _this.getSignal = function () {
      (0, _utils.throwError)('You are grabbing a signal before controller has initialized, please wait for "initialized" event');
    };

    _this.options = options;
    _this.catch = config.catch || null;
    _this.devtools = devtools;
    _this.module = new _Module2.default(_this, [], {
      state: state,
      signals: signals,
      modules: modules
    });
    _this.model = new config.Model(_this);

    _this.contextProviders = [(0, _Controller2.default)(_this)].concat(_this.devtools ? [(0, _Debugger2.default)()] : []).concat((0, _utils.isDeveloping)() ? [_VerifyProps2.default] : []).concat(_this.model.StateProvider(_this.devtools), (0, _Resolve2.default)()).concat(providers.concat((0, _utils.getProviders)(_this.module)));

    if (typeof window !== 'undefined' && window.CEREBRAL_STATE) {
      Object.keys(window.CEREBRAL_STATE).forEach(function (statePath) {
        _this.model.set((0, _utils.ensurePath)(statePath), window.CEREBRAL_STATE[statePath]);
      });
    }

    if (_this.devtools) {
      _this.devtools.init(_this);
    }

    if (!_this.devtools && (0, _utils.isDeveloping)() && typeof navigator !== 'undefined' && /Chrome/.test(navigator.userAgent)) {
      console.warn('You are not using the Cerebral devtools. It is highly recommended to use it in combination with the debugger: http://cerebraljs.com/docs/get_started/debugger.html');
    }

    _this.getSignal = getSignal;

    _this.model.flush();

    _this.emit('initialized');
    return _this;
  }
  /*
    Uses function tree to run the array and optional
    payload passed in. The payload will be checkd
  */


  _createClass(BaseController, [{
    key: 'runSignal',
    value: function runSignal(name, signal) {
      var _this2 = this;

      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      if (this.devtools && (!(0, _utils.isObject)(payload) || !(0, _utils.isSerializable)(payload))) {
        console.warn('You passed an invalid payload to signal "' + name + '". Only serializable payloads can be passed to a signal. The payload has been ignored. This is the object:', payload);
        payload = {};
      }

      if (this.devtools) {
        payload = Object.keys(payload).reduce(function (currentPayload, key) {
          if (!(0, _utils.isSerializable)(payload[key], _this2.devtools.allowedTypes)) {
            console.warn('You passed an invalid payload to signal "' + name + '", on key "' + key + '". Only serializable values like Object, Array, String, Number and Boolean can be passed in. Also these special value types:', _this2.devtools.allowedTypes);

            return currentPayload;
          }

          currentPayload[key] = (0, _utils.forceSerializable)(payload[key]);

          return currentPayload;
        }, {});
      }

      this.run(name, signal, payload, function (error) {
        if (error) {
          var signalPath = error.execution.name.split('.');
          var signalCatch = signalPath.reduce(function (currentModule, key, index) {
            if (index === signalPath.length - 1 && currentModule.signals[key]) {
              return currentModule.signals[key].catch;
            }

            return currentModule ? currentModule.modules[key] : null;
          }, _this2.module);

          // if signal doesn't have a catch method and we have a global catch, try using it
          if (!signalCatch) {
            if (_this2.catch instanceof Map) {
              signalCatch = _this2.catch;
            } else {
              throw error;
            }
          }

          if (signalCatch instanceof Map) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;

            try {
              for (var _iterator = signalCatch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = _slicedToArray(_step.value, 2),
                    errorType = _step$value[0],
                    signalChain = _step$value[1];

                if (error instanceof errorType) {
                  _this2.runSignal('catch', signalChain, error.payload);

                  return;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          throw error;
        }
      });
    }
    /*
      Returns a function which binds the name/path of signal,
      and the array. This allows view layer to just call it with
      an optional payload and it will run
    */

  }, {
    key: 'getSignal',
    value: function getSignal(path) {
      var pathArray = (0, _utils.ensurePath)(path);
      var signalKey = pathArray.pop();
      var module = pathArray.reduce(function (currentModule, key) {
        return currentModule ? currentModule.modules[key] : undefined;
      }, this.module);
      var signal = module && module.signals[signalKey];

      return signal && signal.run;
    }
  }, {
    key: 'addModule',
    value: function addModule(path, module) {
      var pathArray = path.split('.');
      var moduleKey = pathArray.pop();
      var parentModule = (0, _utils.getModule)(pathArray, this.module);
      parentModule.modules[moduleKey] = new _Module2.default(this, path.split('.'), module);

      if (module.provider) {
        this.contextProviders.push(module.provider);
      }

      this.emit('moduleAdded', path, module);
    }
  }, {
    key: 'removeModule',
    value: function removeModule(path) {
      if (!path) {
        console.warn('Controller.removeModule requires a Module Path');
        return null;
      }

      var pathArray = path.split('.');
      var moduleKey = pathArray.pop();
      var parentModule = (0, _utils.getModule)(pathArray, this.module);

      var module = parentModule.modules[moduleKey];

      if (module.provider) {
        this.contextProviders.splice(this.contextProviders.indexOf(module.provider), 1);
      }

      delete parentModule.modules[moduleKey];

      this.emit('moduleRemoved', path, module);
    }
  }]);

  return BaseController;
}(_functionTree2.default);

exports.default = BaseController;
//# sourceMappingURL=BaseController.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/cerebral/lib/BaseController.js
// module id = 279
// module chunks = 0